import { useVuelidate } from "@vuelidate/core";
import { nextTick } from "vue";

export function useFormValidation(validations, state) {
    const v$ = useVuelidate(validations, state);
    const validateForm = async ({ dontScrollToError } = { dontScrollToError: false }) => {
        const isFormCorrect = await v$.value.$validate();
        if (!isFormCorrect && !dontScrollToError) {
            document
                .querySelector("[data-error]")
                ?.scrollIntoView({ behavior: "smooth", block: "end", inline: "end" });
        }
        return isFormCorrect;
    };
    const resetFrom = async () => nextTick(() => v$.value.$reset());
    return { v$, validateForm, resetFrom };
}
